import apiClient from './apiClient';

export const fetchContent = async () => {
  try {
    const r = await apiClient.get('/rubrica.php');
    return r.data;
  } catch (err) {
    console.error('Errore fetch rubrica:', err);
    throw err;
  }
};

export const saveContent = async (content) => {
  try {
    const r = await apiClient.post('/rubrica.php?action=save', { content });
    return r.data;
  } catch (err) {
    console.error('Errore salvataggio rubrica:', err);
    throw err;
  }
};
